import React, { Component } from "react";
import "./scroll.css";
import { FaAngleUp } from "react-icons/fa";

// const ps = {
//   PaddingLeft: "3px",
//   PaddingRight: "3px",
//   backgroundColor: "aqua",
//   position: "fixed",
//   // bottom: "10px",
//   // right: "10px",
//   // zIndex: "1",
// };

class ScrollTopButton extends Component {
  state = {
    intervalId: 0,
  };

  // scrollStep = ()=> {
  //   if (window.pageYOffset !== 0) {
  //       clearInterval(this.state.intervalId);
  //   }
  //   window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
  // }

  // scrollToTop =()=> {
  //   let intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
  //   this.setState({ intervalId: intervalId });
  // }
  scrollToTop = () => {
    window.scroll(0, 0);
  };
  render() {
    return (
      <span className="" onClick={this.scrollToTop} 
       style={{ position:'fixed', bottom:'10px',right:'15px',}}
      >
        <FaAngleUp className="icon-scroll"  />
      </span>
    );
  }
}

export default ScrollTopButton;
